module.exports = __webpack_public_path__ + "static/media/sppu_logo.f1a62bda.png";